"use strict";

exports.__esModule = true;
exports.isIE11 = exports.hasDataViewBug = void 0;
var _setup = require("./_setup.js");
var _hasObjectTag = _interopRequireDefault(require("./_hasObjectTag.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// In IE 10 - Edge 13, `DataView` has string tag `'[object Object]'`.
// In IE 11, the most common among them, this problem also applies to
// `Map`, `WeakMap` and `Set`.
// Also, there are cases where an application can override the native
// `DataView` object, in cases like that we can't use the constructor
// safely and should just rely on alternate `DataView` checks
var hasDataViewBug = exports.hasDataViewBug = _setup.supportsDataView && (!/\[native code\]/.test(String(DataView)) || (0, _hasObjectTag.default)(new DataView(new ArrayBuffer(8)))),
  isIE11 = exports.isIE11 = typeof Map !== 'undefined' && (0, _hasObjectTag.default)(new Map());